import 'exhibit/scss/_exhibit.scss'
import $ from 'jquery'
import MediaQueries from "media-queries"
import Mustache from 'mustache'

//PolyFill
var URLSearchParams = require('url-search-params');

const DETAIL_TEMPLATE = require('../assets/exhibit-template.html');
const MD_PROXY = require('proxy/proxy_config.js');
const line_start = wp_helpers.plugin_url + '/assets/line-start.svg';
const line_odd =  wp_helpers.plugin_url +'/assets/line-odd.svg';
const line_even =  wp_helpers.plugin_url +'/assets/line-even.svg';
const line_end =  wp_helpers.plugin_url +'/assets/line-end.svg';
class MdExhibit {
   constructor(elem) {
      const $this = $(elem);

      this.elem = elem;
      this.headlineLevel = $this.data("headline-level") ? parseInt($this.data("headline-level")) : 2;
      this.ajaxUrl = $this.data("ajax-url");
      this.jsonSourceUrl = $this.data("ajax-url") + "&output=json";
      this.assetUriObject = new URL( this.jsonSourceUrl );
      this.assetUri = this.assetUriObject.protocol + "//" + this.assetUriObject.host + "/";
      this.assetUriSubdomain = this.assetUriObject.hostname.split('.');
      this.assetUriSubdomain  = this.assetUriSubdomain.shift();
      this.objectId = this.assetUriObject.searchParams.get("oges");
      this.detailUrl = $this.attr("data-detail-url") ? $this.attr("data-detail-url") : false;

      this.image = $(".image", elem).length ? 
                  new Array({"imagePath": $(".image", elem).html(), 
                             "image_text_override":$(".image-text", elem).html()}): null;
      this.headline = $(".headline", elem).length ? $(".headline", elem).html() : null;
      this.description = $(".description", elem).length ? $(".description", elem).html(): null;
      this.text = $(".text", elem).length ? $(".text", elem).html() : null;
      this.data = $(".data", elem).length ? $(".data", elem).html() : null;

      //Clean-Up
      $(".image", elem).remove();
      $(".image-text", elem).remove();
      $(".headline", elem).remove();
      $(".description", elem).remove();
      $(".text", elem).remove();
      $(".data", elem).remove();

      this.currentJson = {};

      //Text-Variables
      this.textVariables = {
         "rights": $this.data("text-rights"),
         "detailLinkText": $this.data("detail-link-text"),
         "lightboxText": $this.data("lightbox-text"),
         "error": $this.data("text-error"),
      }

      const resultXHR = this.get_ajax_result(this.jsonSourceUrl);
      $.when(resultXHR).always((result) => {

         this.html_output(result);
      });
      this.init_events();
   }

   get_ajax_result(jsonUrl) {

      $(".exhibit-content", this.elem).addClass("loading");

      const objectlist = MD_PROXY.ajax(jsonUrl);

      this.currentJson = objectlist;
      return objectlist;
   }

   html_output(result) {
      if (result.error !== "error") {
         const name = result.object_name ? result.object_name : null,
            description = result.object_description ? result.object_description.replace(new RegExp('\r?\n','g'), '<br />') : null,
            eventsObject = result.object_events ? result.object_events : null,
            dimensions = result.object_dimensions ? result.object_dimensions : null,
            inventorynumber = result.object_inventory_number ? result.object_inventory_number : null,
            material = result.object_material_technique ? result.object_material_technique : null,
            inscription = result.inscription ? result.inscription : null,
            type = result.object_type ? result.object_type : null,

            institution = result.object_institution ? result.object_institution : 1;

         let images = new Array();

         //EvenetNamen anpassen, sodass kein gruscht mehr dransteht
         let correctedEventsObject = eventsObject?.filter(function(object) {
            if (typeof object.event_name !== 'undefined') {
               let correctedName = object.event_name.substr(0, object.event_name.indexOf('---'));
               correctedName = correctedName.replace("[", "");
               correctedName = correctedName.replace("]", "");

               object.event_name = correctedName;
            }
            if (object.event_people_certain === "j" || object.event_people_certain === "") { //remove from JSON if its certain
               delete object.event_people_certain;
            }
            if (object.event_place_certain === "j" || object.event_place_certain === "") { //remove from JSON if its certain
               delete object.event_place_certain;
            }
            if (object.event_time_certain === "j" || object.event_time_certain === "") { //remove from JSON if its certain
               delete object.event_time_certain;
            }
            //Alle Objekte außer "gezeichnet" entfernen.
            if(
               object.event_type === 19
               ||
               object.event_type === 3 //Veröffentlicht
            ){
               return object;
            } 
         });

         const detailview = MD_PROXY.ajax(this.assetUri+"index.php?t=institution&instnr="+institution.institution_id+"&output=json");

         detailview.always((data) => {

            let subset = data.md_subset ? data.md_subset : data.subset;

            this.assetUri = this.assetUri + "data/"+subset+"/";

            //Add Data to the images
            result.object_images?.map((singleImage, key) => {
               const image_owner = singleImage.owner;
               const image_description = singleImage.beschreibung;
               const image_name = singleImage.name;
               const image_creator = singleImage.creator;
               const image_rights = singleImage.rights;

               let imagePath;
               if (singleImage.filename_loc.startsWith("http") || singleImage.filename_loc.startsWith("HTTP")) {
                  imagePath = singleImage.filename_loc;
               } else {
                  imagePath = this.assetUri + singleImage.folder + "/" + singleImage.filename_loc;
               }

               let image = {
                  image_owner: image_owner,
                  image_description: image_description,
                  image_name: image_name,
                  image_creator: image_creator,
                  image_rights: image_rights,
                  imagePath: imagePath
               }

               images.push(image)
            });

            let objectIdParam = this.objectId ? "?dk_object_id="+this.objectId : "";

            const view = {
               name: this.headline ? this.headline : name,
               headlineLevel: this.headlineLevel,
               headlineLevel2: this.headlineLevel+1,
               headlineLevel3: this.headlineLevel+2,
               description: this.description ? this.description: description,
               text: this.text,
               data: this.data,
               eventsObject: correctedEventsObject,
               inventorynumber: inventorynumber ? inventorynumber : null,
               dimensions: dimensions ? dimensions : null,
               material: material ? material : null,
               inscription: inscription ? inscription : null,
               images: this.image ? this.image : images,
               type: type ? type : null,
               textVariables: this.textVariables ? this.textVariables : null,
               detailUrl: this.detailUrl ? this.detailUrl + objectIdParam : false
            }

            //console.log("data", this.data);
            //console.log("events", correctedEventsObject);
            const detailHTML = Mustache.render(DETAIL_TEMPLATE, view);

            $(".exhibit-content", this.elem).prepend(detailHTML);
            $(".exhibit-content", this.elem).removeClass("loading");
         });
      } else {
         $(".exhibit-content", this.elem).append("<p class='error'>"+textVariables.error+"</p>");
         $(".exhibit-content", this.elem).removeClass("loading");
      }
   }

   init_events() {
      $( ".next", this.elem).on("click", (e)=>{
         e.preventDefault();
         if( $(e.currentTarget).hasClass("end") ){
            $("html,body").animate({
               scrollTop: $(this.elem).offset().top + $(this.elem).outerHeight() - 120 //Höhe des Pseudo-Elements ("Fini") - Abstand nach oben 32px
           }, 1000, "swing");
         }else{
            $("html,body").animate({
               scrollTop: $(".exhibit-content", this.elem).offset().top
           }, 1000, "swing");
         }
      })
      $(this.elem).on("click", ".lightbox-trigger", (e) => {
         e.preventDefault();
         let elem = e.currentTarget;
         let img_src = $(elem).attr("href");
         let img_rights = $("img", elem).attr("data-img-rights");
         if(!$(elem).hasClass("open")){
            $(elem).append("<div class='lightbox-background'></div>");
            $(".lightbox-background", elem).append("<figure><img src='"+img_src+"'><figcaption>"+img_rights+"</figcaption></figure>");
            $(elem).addClass("open");
         }
      })
      $(this.elem).on("click", ".lightbox-background", (e) => {
         e.preventDefault();
         e.stopPropagation();
         $(e.currentTarget).closest(".lightbox-trigger").removeClass("open");
         $(e.currentTarget).remove();
      })
   }
}

class MdExhibitManager {
   constructor() {
      let i = 1;
      let length = $('.md-exhibit').toArray().length;
      this.mdExhibits = $('.md-exhibit').toArray().reduce((a, e) => {
         if(i === 1){
            $(e).addClass("first");
            $(".line", e).html('<img src="'+line_start+'" alt=""/>');
         }else if(i === length){
            let svg_img= $(e).find(".next svg").prop('outerHTML');
            $(e).addClass("last");
            $(e).append('<a class="next end" href="#"><div class="button-img">'+svg_img+'</div><div class="line"><img src="'+line_end+'" alt=""/></div></a>');
         }
         if(i%2 === 0){
            $(e).addClass("even");
            $(".line", e).html('<img src="'+line_even+'" alt=""/>');
         }else{
            $(e).addClass("odd");
            $(".line", e).html('<img src="'+line_odd+'" alt=""/>');
         }
         i++;
         return {
         [e]: new MdExhibit(e),
         ...a
      }}, {});
   }
}

$(function() {
   if ($('.md-exhibit').length > 0) {
      Mustache.parse(DETAIL_TEMPLATE);
      const mdExhibit = new MdExhibitManager();
   }
});